import { render } from "./DiscountAction.vue?vue&type=template&id=1a73e983&ts=true"
import script from "./DiscountAction.vue?vue&type=script&lang=ts"
export * from "./DiscountAction.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__